var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GLTFLoader } from "../../external/gltf2";
import { GLTFLoader as OldGLTFLoader } from "../../external/gltf";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
/**
 * Our implementation of loading textures from remote endpoints.
 */
export class GltfLoader {
    static parseGlb(data, baseUrl, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                GltfLoader.LOADER.parse(data, baseUrl, (v) => {
                    resolve(v);
                }, (v) => {
                    try {
                        GltfLoader.LOADER_OLD.parse(data, (g) => resolve(g), baseUrl, options);
                    }
                    catch (_a) {
                        reject(v);
                    }
                }, options);
            });
        });
    }
    static configureLoaders(url) {
        this.LOADER = loaderInit(url);
    }
}
GltfLoader.LOADER_OLD = new OldGLTFLoader();
GltfLoader.LOADER = loaderInit();
function loaderInit(url) {
    const dracoLoader = new DRACOLoader();
    if (url !== undefined) {
        dracoLoader.setDecoderPath(url);
    }
    const loader = new GLTFLoader();
    loader.setDRACOLoader(dracoLoader);
    return loader;
}
